import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { Modal } from "ui";

import { useDeleteVideo } from "../../../apis";
import { DeleteVideoModalProps } from "./DeleteVideoModal.types";

import styles from "./DeleteVideoModal.module.scss";

const DeleteVideoModal = ({
  isOpen,
  id,
  onClose,
  onDeleteSuccess
}: DeleteVideoModalProps) => {
  const { t } = useTranslation();

  const { isLoading: isLoadingDeleteVideo, mutate: mutateDeleteVideo } =
    useDeleteVideo({
      onSuccess: () => {
        onClose();
        onDeleteSuccess();
        toast.success(t("Video deleted successfully"));
      }
    });

  const onDeleteVideo = () => {
    mutateDeleteVideo(id);
  };

  return (
    <Modal
      type="delete"
      isOpen={isOpen}
      title="Delete Video"
      isLoading={isLoadingDeleteVideo}
      okText="Delete"
      onOk={onDeleteVideo}
      contentClassName={styles.deleteVideoModal}
      onClose={onClose}
    >
      <p className={styles.deleteVideoModal_text}>
        {t("Are you sure you want to delete this video?")}
      </p>
    </Modal>
  );
};

export default DeleteVideoModal;
